import type { UnifiedCitation } from "@memorang/types/src/session/new-session";

export const getShortenedText = (text: string, wordLimit = 8) => {
	const cleanedText = text.replace(/\n/g, " ");
	const words = cleanedText.split(" ");
	if (words.length > wordLimit) {
		return `${words.slice(0, wordLimit).join(" ")}...`;
	}
	return cleanedText;
};

export const getChapterTextAndSource = (reference: UnifiedCitation) => {
	const source = reference.sourceId || reference.id;
	const title = reference.title;
	const referenceText = reference.pageContent.replace("\\n", "");

	const shortenedReferenceText = getShortenedText(referenceText);

	return {
		source,
		title,
		shortenedReferenceText,
	};
};
